import { useSelector } from "react-redux";
import type { IRootState } from "../../redux/store";
import { type TTab } from "../../utils";
import style from "./Form.module.scss";
import Avatar from "./NewInputs/AvatarFromBlock/Avatar";
import NewScene from "./NewInputs/SceneFromBlock/NewScene";
import { useTabs } from "../Tabs/TabsProvider";

const TabStates: Partial<Record<TTab, any>> = {
	appearance: Avatar,
	scene: NewScene,
};

interface Props {
	getBrainId: () => void;
}

export const Form: React.FC<Props> = ({ getBrainId }) => {
	const formData = useSelector((state: IRootState) => state.avatarForm);
	const { activeTab, setActiveTab } = useTabs();
	const Component = TabStates[activeTab] || (() => {});
	
	const handleSaveForm = () => {
		switch (activeTab) {
			case "appearance":
				setActiveTab("scene");
				break;
			case "scene":
				setActiveTab("preview");
				break;
			default:
				setActiveTab("appearance");
				break;
		}
	};

	return (
		<div className={style.container}>
			<Component
				{...formData}
				handleSaveForm={handleSaveForm}
				getBrainId={getBrainId}
			/>
		</div>
	);
};
